import { Tooltip as TooltipMantine, TooltipProps } from "@mantine/core";
import { useShownColorScheme } from "hooks/useShownColorScheme";
import { TOOLTIP_SHOW_TIMEOUT } from "config/constants";

export const Tooltip = ({ children, ...rest }: TooltipProps) => {
  const colorScheme = useShownColorScheme();

  return (
    <TooltipMantine
      openDelay={TOOLTIP_SHOW_TIMEOUT}
      {...rest}
      withArrow
      withinPortal
      color={colorScheme === "dark" ? "gray" : "dark"}
    >
      {children}
    </TooltipMantine>
  );
};
